import styled from 'styled-components';

export const Container = styled.div`
  height: 950px;

  @media only screen and (max-width: 1000px) {
    height: auto;
    margin-top: 12vh;
  }
`;

export const PortfolioContent = styled.div`
  max-width: 1240px;
  margin: 10px auto;
`;

export const PortfolioHeader = styled.div`
  padding-left: 20px;

  div {
    max-width: 180px;

    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;

    h1 {
      font-weight: 900;
      font-size: 60px;
      line-height: 90px;

      color: rgba(39, 39, 39, 0.6);
    }
  }

  a {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    text-decoration: none;
    transition: color 0.2s;

    color: #272727;

    :hover {
      color: #386882;
    }
  }

  @media only screen and (max-width: 1000px) {
    text-align: center;

    div {
      max-width: none;

      h1 {
        font-size: min(10vw, 40px);
        line-height: min(10vw, 60px);
      }
    }

    a {
      font-size: min(4vw, 18px);
      line-height: min(4vw, 27px);
    }
  }
`;

// ---> Start Portfolio <---

export const PortfolioListContainer = styled.div`
  position: relative;
  display: flex;
  margin: 30px auto;
`;

export const PortfolioList = styled.div`
  display: flex;
  position: relative;
  scroll-behavior: smooth;
  overflow-x: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const PortfolioNextContainer = styled.div`
  z-index: 1;

  position: absolute;
  right: 0px;
  height: 100%;
  width: 100px;

  display: flex;
  flex: 1;
  align-items: center;

  background: rgb(0, 0, 0);
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
`;

export const PortfolioNextButton = styled.button`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  margin-right: 25px;

  height: 100%;

  background: none;
  border: none;

  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #ffffff;

  svg {
    margin-left: 10px;
  }

  :hover {
    cursor: pointer;
    color: rgba(255, 255, 255, 0.6);
  }

  @media only screen and (max-width: 1000px) {
    div {
      display: none;
    }
  }
`;

// ---> Start Portfolio <---
